import { render } from "./ShareholdingStatistics.vue?vue&type=template&id=14dd8160"
import script from "./ShareholdingStatistics.vue?vue&type=script&lang=ts"
export * from "./ShareholdingStatistics.vue?vue&type=script&lang=ts"
script.render = render

export default script